
export class Usuario {
    nome: string;
    senha: string;
    login: string;
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/login/usuario.ts